import { render, staticRenderFns } from "./Consultar.vue?vue&type=template&id=56b45f78&scoped=true&"
import script from "./Consultar.vue?vue&type=script&lang=js&"
export * from "./Consultar.vue?vue&type=script&lang=js&"
import style0 from "./Consultar.vue?vue&type=style&index=0&id=56b45f78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b45f78",
  null
  
)

export default component.exports